import { useMemo } from 'react'

import useMenusStore from 'src/stores/useMenusStore'
import useProductMatchParams from './useProductMatchParams'

const useGetCurrentProductName = () => {
  const menus = useMenusStore(s => s.menus)

  const routeParams = useProductMatchParams()

  const { product: productFormPathname, subProduct, program } = routeParams?.params || {}

  const elementCode = subProduct || productFormPathname
  const programCode = program ? `-${program}` : ''

  const element = useMemo(() => {
    if (!menus) return null
    return menus.reduce<{ parentName: string; name: string } | null>((acc, category) => {
      if (acc) return acc
      const product = category.children.find(p => p.code === productFormPathname)
      if (product) {
        const sbp = product.children.find(p => p.code === subProduct)
        if (sbp) {
          if (program) {
            const sbpProgram = sbp?.program_list?.find(p => p.id?.toString() === program.toString())
            if (sbpProgram) {
              return {
                parentName: product.name,
                name: sbpProgram.label,
              }
            }
          }
          return {
            parentName: product.name,
            name: sbp.name,
          }
        }
      }
      return null
    }, null)
  }, [elementCode, programCode, menus])

  return element
}

export default useGetCurrentProductName
